import { parseNumberFilter, parseTextFilter, toFilterText, toPeriodSearch } from '@/utils/filters';
import { BATCH_STAGE_VALUES } from '@/constants/batchStages';
import type { BatchSearch, BatchStageValue } from '../types/publish.types';

type FilterValues = Record<string, string>;

type BatchFilterSearch = Pick<
  BatchSearch,
  'dateFrom' | 'dateTo' | 'trnDateFrom' | 'trnDateTo' | 'userId' | 'batchStage'
>;

export function toBatchFilterValues(search: BatchFilterSearch): FilterValues {
  return {
    dateFrom: toFilterText(search.dateFrom),
    dateTo: toFilterText(search.dateTo),
    trnDateFrom: toFilterText(search.trnDateFrom),
    trnDateTo: toFilterText(search.trnDateTo),
    userId: toFilterText(search.userId),
    batchStage: toFilterText(search.batchStage),
  };
}

export function toBatchFilterSearch(values: FilterValues): BatchFilterSearch {
  return {
    ...toPeriodSearch(values),
    trnDateFrom: parseTextFilter(values.trnDateFrom),
    trnDateTo: parseTextFilter(values.trnDateTo),
    userId: parseNumberFilter(values.userId),
    batchStage: parseBatchStage(values.batchStage),
  };
}

function parseBatchStage(value: string | undefined): BatchStageValue | undefined {
  const text = parseTextFilter(value);
  if (text === undefined) return undefined;
  return BATCH_STAGE_VALUES.find((stage) => stage === text);
}
